<template>
  <div class="level-complete">
    <video
      class="success-video"
      src="@/assets/congrats/benny-win.mp4"
      autoplay
      muted
      loop
      playsinline
    />
    <canvas ref="confettiCanvas" class="confetti-canvas"></canvas>
    <p class="message">
      {{ message }}
    </p>
  </div>
</template>

<script>
import { nextTick } from 'vue';

export default {
  name: "LevelComplete",
  props: {
    message: {
      type: String,
      default: "✅ Great Job!!",
    },
  },
  mounted() {
    // Finalize as finished — triggers daily aggregation + console print
    this.$store.dispatch("levelSessions/finishSession");
    console.log('Level Completed Successfully!');

    nextTick(() => {
      this.launchConfetti();
      window.addEventListener('resize', this.resizeConfettiCanvas);
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.resizeConfettiCanvas);
    if (this.confettiAnimFrame) cancelAnimationFrame(this.confettiAnimFrame);
  },
  methods: {
    resizeConfettiCanvas() {
      const canvas = this.$refs.confettiCanvas;
      if (!canvas) return;
      const rect = canvas.getBoundingClientRect();
      canvas.width = rect.width * window.devicePixelRatio;
      canvas.height = rect.height * window.devicePixelRatio;
    },
    launchConfetti() {
      const canvas = this.$refs.confettiCanvas;
      if (!canvas) return;
      this.resizeConfettiCanvas();

      const ctx = canvas.getContext('2d');
      const w = () => canvas.width;
      const h = () => canvas.height;

      const NUM_CONFETTI = 90;
      const colors = [
        '#FF5F67', '#FFD847', '#75E06B', '#38D5F4', '#A084EA',
        '#F672D7', '#FFB447', '#6AC5D8', '#EA6F79', '#FFF241'
      ];

      function randomColor() {
        return colors[Math.floor(Math.random() * colors.length)];
      }
      function randomBetween(a, b) {
        return Math.random() * (b - a) + a;
      }

      const particles = [];
      for (let i = 0; i < NUM_CONFETTI; i++) {
        particles.push({
          x: randomBetween(0, w()),
          y: randomBetween(-h() * 0.3, h() * 0.3),
          r: randomBetween(8, 18),
          d: randomBetween(2, 6),
          color: randomColor(),
          tilt: randomBetween(-12, 12),
          tiltAngle: randomBetween(0, Math.PI * 2),
          tiltAngleIncremental: randomBetween(0.04, 0.12),
        });
      }

      let animationRunning = true;
      const animDuration = 4000;
      const endTime = Date.now() + animDuration;

      const draw = () => {
        ctx.clearRect(0, 0, w(), h());
        particles.forEach(p => {
          ctx.save();
          ctx.beginPath();
          ctx.ellipse(
            p.x, p.y, 
            p.r, p.r * 0.6, 
            p.tilt, 0, 2 * Math.PI
          );
          ctx.fillStyle = p.color;
          ctx.globalAlpha = 0.85;
          ctx.fill();
          ctx.restore();
        });
      };

      const update = () => {
        for (let p of particles) {
          p.y += Math.cos(p.d) + 2 + p.r / 10;
          p.x += Math.sin(p.d) * 2;
          p.tiltAngle += p.tiltAngleIncremental;
          p.tilt = Math.sin(p.tiltAngle) * 16;

          if (p.y > h() + 60) {
            p.x = randomBetween(0, w());
            p.y = randomBetween(-40, -10);
            p.tilt = randomBetween(-12, 12);
          }
        }
      };

      this.resizeConfettiCanvas = () => {
        if (!this.$refs.confettiCanvas) return;
        const rect = this.$refs.confettiCanvas.getBoundingClientRect();
        this.$refs.confettiCanvas.width = rect.width * window.devicePixelRatio;
        this.$refs.confettiCanvas.height = rect.height * window.devicePixelRatio;
      };

      const animate = () => {
        if (!animationRunning) return;
        draw();
        update();
        if (Date.now() < endTime) {
          this.confettiAnimFrame = requestAnimationFrame(animate);
        } else {
          animationRunning = false;
          ctx.clearRect(0, 0, w(), h());
        }
      };
      animate();
    }
  }
};
</script>

<style scoped>
.level-complete {
  position: relative;
  width: 100%;
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.success-video {
  width: 80%;
  max-width: 400px;
  border-radius: 1rem;
  z-index: 3;
  box-shadow: 0 2px 12px rgba(0,0,0,0.11);
  position: relative;
}
.confetti-canvas {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
  display: block;
}
.message {
  font-size: 3rem;
  font-weight: bold;
  text-align: center;
  margin-top: 20px;
  z-index: 12;
  color: #2d2949;
  text-shadow: 1px 2px #fff6, 0 4px 12px #ffc6;
  position: relative;
}
@media (max-width: 600px) {
  .message { font-size: 2.1rem; }
  .success-video { width: 97%; max-width: 98vw; }
}
</style>